import * as React from "react";
import Icon, { IconType } from "./icon";

export interface IconBtnProps {
    type: IconType;
    className?: string;
    url?: string;
}

export interface IconBtnState {
}

export default class IconBtn extends React.Component<IconBtnProps, IconBtnState> {
  constructor(props: IconBtnProps) {
    super(props);

    this.state = {
    };
  }

  public openURL(url) {
      if (url !== null) {
          window.open(this.props.url, "_blank");
      }
  }

  public render() {

    return (
      <div className={"icon-btn " + this.props.className}>
            <Icon type={this.props.type} onClick={() => this.openURL(this.props.url)}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/icon-btn.tsx